/*!
 * devextreme-vue
 * Version: 21.2.12
 * Build date: Fri Dec 09 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createExtensionComponent = exports.createConfigurationComponent = exports.createComponent = void 0;
var vue2Stategy = __importStar(require("./strategy/vue2/index"));
var vue3Stategy = __importStar(require("./strategy/vue3/index"));
var version_1 = require("./version");
var strategy = version_1.isVue3() ? vue3Stategy : vue2Stategy;
exports.createComponent = strategy.createComponent;
exports.createConfigurationComponent = strategy.createConfigurationComponent;
exports.createExtensionComponent = strategy.createExtensionComponent;
